import {
  doc,
  getDoc,
  setDoc,
  collection,
  getDocs,
  updateDoc,
  serverTimestamp,
} from 'firebase/firestore';
import { db } from '../firebase/config';

export const PORTAL_WELCOME_DOC_ID = 'welcome_practice_info';

export const PRACTICE_INFO_MESSAGE = {
  authorName: 'YAU System',
  title: 'Practice and Game Information',
  body:
    'Hey, for practice updates and or game times and information for practice locations and or times, please call the main number, which is 800-293-0354 or 301-292-3688 to get updated information about practices, locations, and times for your student.',
};

/**
 * Idempotent: creates the system welcome message once per member.
 */
export async function ensureRegistrationWelcomeMessage(userId) {
  if (!userId) return { ok: false, reason: 'no_user' };
  try {
    const ref = doc(db, 'members', userId, 'portalMessages', PORTAL_WELCOME_DOC_ID);
    const snap = await getDoc(ref);
    if (snap.exists()) {
      return { ok: true, skipped: true };
    }
    await setDoc(ref, {
      title: PRACTICE_INFO_MESSAGE.title,
      authorName: PRACTICE_INFO_MESSAGE.authorName,
      description: PRACTICE_INFO_MESSAGE.body,
      source: 'system',
      kind: 'registration_welcome',
      read: false,
      priority: 'normal',
      targetAgeGroup: 'all',
      targetLocation: 'all',
      targetSport: 'all',
      timestamp: serverTimestamp(),
    });
    return { ok: true, created: true };
  } catch (e) {
    console.error('ensureRegistrationWelcomeMessage:', e);
    return { ok: false, error: e.message };
  }
}

export async function getPortalMessagesForMember(userId) {
  if (!userId) return [];
  try {
    const snap = await getDocs(collection(db, 'members', userId, 'portalMessages'));
    const rows = snap.docs.map((d) => {
      const data = d.data();
      const ts = data.timestamp?.toDate
        ? data.timestamp.toDate()
        : data.timestamp
          ? new Date(data.timestamp)
          : new Date(0);
      return {
        id: `portal:${d.id}`,
        portalDocId: d.id,
        adminPostId: data.adminPostId || d.id,
        sender: data.authorName || 'YAU System',
        subject: data.title || 'Message',
        message: data.description || '',
        timestamp: ts,
        priority: data.priority || 'normal',
        type: 'portal',
        read: data.read === true,
        targetAgeGroup: data.targetAgeGroup ?? 'all',
        targetLocation: data.targetLocation ?? 'all',
        targetSport: data.targetSport ?? 'all',
        imageUrl: data.imageUrl || null,
        source: data.source || 'system',
      };
    });
    rows.sort((a, b) => b.timestamp - a.timestamp);
    return rows;
  } catch (e) {
    console.warn('getPortalMessagesForMember:', e);
    return [];
  }
}

export async function markPortalMessageAsRead(userId, portalDocId) {
  if (!userId || !portalDocId) return;
  const ref = doc(db, 'members', userId, 'portalMessages', portalDocId);
  await updateDoc(ref, { read: true, readAt: serverTimestamp() });
}
